import * as d3 from 'd3';

import { TaskStatus } from '../../models';
import { cancelTextColor, createdTextColor, errorTextColor, startedTextColor, successTextColor } from '../../common/constants';

export const taskResultsScale = d3.scale.ordinal<TaskStatus, string>()
        .domain([
            TaskStatus.Cancelled, TaskStatus.Cancelling, TaskStatus.Completed, TaskStatus.Created,
            TaskStatus.Failed, TaskStatus.Started
        ])
        .range([cancelTextColor, cancelTextColor, successTextColor, createdTextColor, errorTextColor, startedTextColor]);